import type { ChangelogEntry } from "../types";

/**
 * Første del av tilbudsarbeidsrommet: grener på tilbudet og grenen Grunnlag.
 * Bak funksjonsbryteren «Tilbudsarbeidsrom».
 */
export const TILBUDSARBEIDSROM_GRUNNLAG_2026_10: ChangelogEntry = {
  id: "2026-10-27-tilbudsarbeidsrom-grunnlag",
  date: "2026-10-27",
  title: "Tilbudet får grener, og Grunnlag samler det du vet om oppdraget",
  summary: "Første del av tilbudsarbeidsrommet: grenene Grunnlag, Idé, Budsjett, Presentasjon og Tilbud på hvert tilbud.",
  sections: [
    {
      heading: "Tilbud",
      items: [
        {
          title: "Grener på tilbudet",
          kind: "nytt",
          featureFlag: "feature_offer_workspace",
          body: "Under tilbudsheaderen ligger nå grenene Grunnlag, Idé, Budsjett, Presentasjon og Tilbud. Budsjett er tilbudssiden slik du kjenner den. Du kan hoppe fritt mellom grenene, og hver gren viser om den er tom, påbegynt eller klar. Idé, Presentasjon og Tilbud kommer i senere oppdateringer.",
        },
        {
          title: "Grunnlag med kilder fra kundekortet",
          kind: "nytt",
          featureFlag: "feature_offer_workspace",
          body: "Grunnlag har kort beskrivelse, målgruppe og budsjettramme. Ved siden av ser du notater, referater og e-post fra kundekortet, og velger hvilke som skal brukes når AI senere lager utkast til presentasjonen.",
        },
      ],
    },
  ],
};
